import { render, staticRenderFns } from "./markqueue-orthopedic.vue?vue&type=template&id=077c042e&scoped=true&"
import script from "./markqueue-orthopedic.vue?vue&type=script&lang=js&"
export * from "./markqueue-orthopedic.vue?vue&type=script&lang=js&"
import style0 from "./markqueue-orthopedic.vue?vue&type=style&index=0&id=077c042e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077c042e",
  null
  
)

export default component.exports